import type { ReactNode } from 'react';

const TONES = { celeste: 'var(--bf-chart-1)', green: 'var(--bf-chart-2)', amber: 'var(--bf-chart-3)', red: 'var(--bf-chart-4)' };

function sparkPath(values: number[], w: number, h: number): { line: string; area: string } {
  const max = Math.max(...values, 1);
  const step = values.length > 1 ? w / (values.length - 1) : w;
  const pts = values.map((v, i) => [i * step, h - 2 - (v / max) * (h - 8)] as const);
  const line = pts.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  return { line, area: `${line} L${w},${h} L0,${h} Z` };
}

/**
 * Tarjeta de indicador: punto de color, valor grande, variación y
 * minigráfico de tendencia al pie (mismo lenguaje que el dashboard de Guardians).
 */
export function Kpi({
  label,
  value,
  delta,
  deltaMuted,
  icon,
  tone = 'celeste',
  trend,
}: {
  label: string;
  value: ReactNode;
  delta?: ReactNode;
  deltaMuted?: boolean;
  icon?: ReactNode;
  tone?: keyof typeof TONES;
  trend?: number[];
}) {
  const w = 300;
  const h = 38;
  const data = trend && trend.length > 1 ? trend : [0, 0];
  const { line, area } = sparkPath(data, w, h);
  return (
    <div className="bf-kpi" style={{ ['--_c' as string]: TONES[tone] }}>
      <div className="bf-kpi-head">
        <span className="bf-kpi-label">{label}</span>
        {icon}
      </div>
      <div className="bf-kpi-value">{value}</div>
      {delta && <div className={deltaMuted ? 'bf-kpi-delta bf-kpi-delta--muted' : 'bf-kpi-delta'}>{delta}</div>}
      <svg className="bf-kpi-spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden>
        <path d={area} fill="currentColor" opacity="0.14" />
        <path d={line} fill="none" stroke="currentColor" strokeWidth="1.6" vectorEffect="non-scaling-stroke" />
      </svg>
    </div>
  );
}
